import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LinkButton from 'components/LinkButton';
import ConfirmDialog from 'scenes/Dialog/components/ConfirmDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import ShowMore from 'components/ShowMore';

import { FileHelper } from 'helpers/file';
import { ENDPOINT } from 'constants/endpoints';
import { useApi } from 'hooks/useApi';

const AdditionalFilesItem = props => {
  const { record, onRemove } = props;
  const { FileID, FileName, FullName, Description, DateUpload } = record;

  const api = useApi();

  const [isDisabled, setDisabled] = useState(false);

  const fullText = [...Description];
  const excerpt = [...(Description.substring(0, 75) + '... ')];

  const handleClickRemove = () => {
    if (!isDisabled) {
      ConfirmDialog({
        dismissWhenClose: true,
        bodyRender:
          'Are you sure you want to remove this file from candidate profile?',
      }).then(() => {
        setDisabled(true);
        api.post(
          ENDPOINT.ACTION.ADDITIONAL_FILE.REMOVE,
          { id: FileID },
          {
            handleError: response => {
              ResponseErrorDialog({ response });
              setDisabled(false);
            },
            handleSuccess: () => onRemove(),
          }
        );
      });
    }
  };

  const handleDownload = () => {
    api.download(
      ENDPOINT.ACTION.ADDITIONAL_FILE.DOWNLOAD,
      { id: FileID },
      {
        handleSuccess: response => {
          FileHelper.downloadInit(response.file, response.filename);
        },
        handleError: response =>
          ResponseErrorDialog({ response: response.data }),
      }
    );
  };

  return (
    <>
      <div className="sidebar__table-row">
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 150px',
          }}
        >
          <div
            className="sidebar__text"
            style={{
              display: 'inline',
              fontSize: '0.8571rem',
            }}
          >
            <LinkButton
              text={FileName}
              controlFunc={handleDownload}
              btnFontWeight="600"
              btnFontSize="0.8571rem"
              underline={false}
              btnFontFamily="Noto Sans"
            />
          </div>
        </div>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 0 95px',
            marginRight: 0,
          }}
        >
          <div className="sidebar__text" style={{ textAlign: 'right' }}>
            {DateUpload}

            <span className="additional-files__delete-file">
              <button
                className="additional-files__delete-btn"
                onClick={handleClickRemove}
              >
                <span className="additional-files__delete-icon" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <div className="sidebar__table-block">
        <div className="sidebar__text sidebar__text--wordbreak">
          {FullName},{' '}
        </div>
        <span className="sidebar__text sidebar__text--wordbreak">
          {Description.length > 74 ? (
            <ShowMore
              renderExcerpt={excerpt}
              renderAll={fullText}
              type="string"
            />
          ) : (
            Description
          )}
        </span>
      </div>
    </>
  );
};

AdditionalFilesItem.propTypes = {
  record: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default AdditionalFilesItem;
